import { render } from "./RadioTypeComponent.vue?vue&type=template&id=5257f402&scoped=true"
import script from "./RadioTypeComponent.vue?vue&type=script&lang=js"
export * from "./RadioTypeComponent.vue?vue&type=script&lang=js"

import "./RadioTypeComponent.vue?vue&type=style&index=0&id=5257f402&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5257f402"]])

export default __exports__